import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { countryOptions } from '@skytech/utils'
import { COUNTRY_FLAGS } from '@skytech/utils'

import type { User, CostObject } from '@/api/demoCustomersApi'
import { TrLink } from '@/components/TrLink'
import Highlight from '@/components/util/Highlight'
import { appRoutes } from '@/util/misc'

export const DemoCustomerListItem: FC<{
  searchFilter: string
  id: number
  name: string
  customerHeadName: string
  users: User[]
  costObjects: CostObject[]
}> = ({ searchFilter, id, name, customerHeadName, users, costObjects }) => {
  const baseLink = appRoutes.demoCustomer.replace(':id', id.toString())
  const firstUserCountryId = costObjects[0].countryId
  const countryName = countryOptions.find(country => country.value === firstUserCountryId)?.label
  const countryNameWithFlag = countryName && `${COUNTRY_FLAGS[countryName]} ${countryName}`

  const numberOfEmployees = costObjects?.length ? costObjects.length.toString() : '-'
  const numberOfUsers = users?.length ? users.length.toString() : '-'

  return (
    <TrLink path={baseLink}>
      <Td>
        <Highlight pattern={searchFilter} text={name} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={customerHeadName} />
      </Td>
      <Td className="center hidden sm:table-cell">
        <Highlight pattern={searchFilter} text={countryNameWithFlag} />
      </Td>
      <Td className="center hidden sm:table-cell">
        <Highlight pattern={searchFilter} text={numberOfUsers} />
      </Td>
      <Td className="center hidden sm:table-cell">
        <Highlight pattern={searchFilter} text={numberOfEmployees} />
      </Td>
    </TrLink>
  )
}
